import { FC, ReactNode, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useAppDispatch } from "redux/hooks";
import { resetTimeOut } from "redux/slices/TimeoutSlice";

import { Col, Row, Seperator } from "../Flex";
import Image, { ICONS } from "../Image";
import { Button, Typography } from "components";
import Modal from "../Modal";

type NoActionForFiveMinProps = {
  children: ReactNode;
};

const NoActionForFiveMin: FC<NoActionForFiveMinProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const TIMEOUT_NUMBER = 360;
  const [startTimeSeconds, setStartTimeSeconds] = useState<number>(
    TIMEOUT_NUMBER
  );

  const [timeoutModalIsOpen, setTimeoutModalIsOpen] = useState(false);

  useEffect(() => {
    let timerId: NodeJS.Timeout;

    if (startTimeSeconds > 0) {
      timerId = setTimeout(() => {
        setStartTimeSeconds(startTimeSeconds - 1);
      }, 1000);
    }
    return () => clearTimeout(timerId);
  }, [startTimeSeconds]);

  useEffect(() => {
    startTimeSeconds === 0 && setTimeoutModalIsOpen(true);
  }, [startTimeSeconds]);

  const handleLogoutClick = () => {
    window.location.reload();
  };

  const mouseMoveTimeout = () => {
    if (startTimeSeconds === 0) return;

    setStartTimeSeconds(TIMEOUT_NUMBER);
    dispatch(resetTimeOut());
    setTimeoutModalIsOpen(false);
  };

  const mouseClickTimeOut = () => {
    if (startTimeSeconds === 0) return;

    setStartTimeSeconds(TIMEOUT_NUMBER);
    dispatch(resetTimeOut());
    setTimeoutModalIsOpen(false);
  };

  return (
    <div
      onMouseMove={() => mouseMoveTimeout()}
      onClick={() => mouseClickTimeOut()}
    >
      <>
        {timeoutModalIsOpen && (
          <Modal
            IconSrc={ICONS.TIMEOUT}
            isClosable={false}
            setIsOpen={setTimeoutModalIsOpen}
            title={t("global_warning").toString()}
            maxWidth={430}
          >
            <Row justifyContent='center' noMargin>
              <Image
                alt='Timeout Icon'
                className='icon-dark-mode'
                height='64px'
                srcSet={ICONS.SAND_WATCH}
                width='64px'
              />
            </Row>

            <Seperator marginTop={15} />

            <Row>
              <Col>
                <Typography align='center' weight='500'>
                  {t("no_action_session_end")}
                </Typography>
              </Col>
            </Row>
            <Seperator marginTop={20} />
            <Row justifyContent='center' isResponsive>
              <Col>
                <Button
                  color='light'
                  onClick={handleLogoutClick}
                  text={t("modal_error_button_title").toString()}
                />
              </Col>
            </Row>
          </Modal>
        )}

        {children}
      </>
    </div>
  );
};

export default NoActionForFiveMin;
